import { createFileRoute } from '@tanstack/react-router';

import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { RolesListPage } from '@/pages/settings/roles/RolesListPage';

export const Route = createFileRoute('/_authenticated/_app/settings/roles/')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageMembers'] }),
	component: RolesListPage,
});
